<template>
  <div class="nameID" :aria-hidden="alertVisible">
    <base-page-struct
      :footerConfig="{
        show: !isGuide && !isShowOrder,
        props: {
          value: !isGuide ? '提交' : '开始拍照',
          disabled: (!isGuide && submitVisible) || (!isAgree && getReason),
        },
        listener: {
          click: submit,
        },
      }"
      :showQa="!isGuide && !isShowOrder"
      :showDesc="false"
      :showTitle="!!getReason && !isGuide && !isShowOrder"
      v-on:toQa="handleGoQuestion"
    >
      <!-- <template #title>
        <div class="name-tips" v-html="getReason"></div>
      </template> -->
      <template #agree>
        <cube-checkbox v-model="isAgree" v-if="getReason">
          <div class="name-tips" v-dompurify-html="getReason"></div>
        </cube-checkbox>
      </template>
      <div class="item-group">
        <div class="item name">
          <span class="item-name">姓名</span>
          <input type="text" placeholder="请填写本人真实姓名" :aria-label="name" v-model="name">
        </div>
        <div class="item">
          <span class="item-name">身份证号</span>
          <input type="text" placeholder="请填写本人身份证号" :aria-label="id_no" v-model="id_no">
          <span class="icon-clear" v-show="id_no" @click="clearText"></span>
          <span class="icon-scan" v-show="!id_no" @click="guide"></span>
        </div>
      </div>
      <div class="guide" v-if="isGuide && !isShowOrder">
        <div class="close" @click="hideGuide"></div>
        <div class="img"><img src="../images/guide_img_id card@3x.png"></div>
        <div class="tips" @click="hideGuide">
          <div class="tip1">照片须符合以下要求</div>
          <div class="tip2">证件信息清晰可见、无反光遮挡<br>证件四角对齐</div>
        </div>
        <div class="btn" @click="photo">开始拍照</div>
      </div>
      <myorders v-if="isShowOrder" @payover="payover"></myorders>
    </base-page-struct>
  </div>
</template>
<script>
import {urlObj} from '../config'
import { setPageTitle } from '@didi/public-sdk'
import { dbridge } from '@didi/driver-bridge'
import { mapGetters } from 'vuex'
import myorders from '../components/myorders'
import { waitBridgeReady, initUnVerifiedRouter, toast, showAlert } from '../api'
import { name_auth_omega_summary } from 'common-js/omega'
import { loadScript } from 'common-js/util/loadScript'
import { rsaEncrypt } from 'common-js/util/tool'
import { UOPLOAD_POTO_CONG } from '../config/const'
import { fetchPost } from 'common-js/api/http.js'
import BasePageStruct from 'components/BasePageStruct/BasePageStruct.vue'
import { sendOmega } from '../config/state'
import { defaultBiz, defaultBizCode } from '../config/utils'

const VERIFY_REANME_TIP = {
  0: '',
  4: '抱歉，您的实名认证失败已达5次，请联系客服。',
  230: '抱歉，实名认证未通过',
  default: '认证失败',
}

export default {
  components: {
    myorders,
    BasePageStruct
  },
  data () {
    return {
      name: '',
      id_no: '',
      isGuide: false,
      hasInBridge: false,
      isShowOrder: false,
      myorders: [],
      fields: [],
      sessionid: '',
      form: null,
      isAgree: false,
      type: 2,
      alertVisible: false,
    }
  },
  computed: {
    ...mapGetters([
      'verifyStatus',
      'cell_id',
      'roleId',
      'orders',
      'ticket',
      'env',
      'getReason',
      'identityCards',
      'unVerified',
      'docId'
    ]),
    submitVisible() {
      return !this.name || !this.id_no
    },
  },
  methods: {
    payover () {
      this.unbind()
    },
    guide () {
      this.isGuide = true
    },
    hideGuide () {
      this.isGuide = false
    },
    testID () {
      if (/^\d{17}(\d|x)$/i.test(this.id_no)) {
        return true
      }
      return false
    },
    setAlertVisible(visible) {
      this.alertVisible = visible
    },
    initScript (cb1, cb2) {
      if (this.env === 'passenger') {
        console.log('inPass')
        // this.faceRegPasser()
        if (!window.D.bridge) {
          loadScript('//static.udache.com/agility-sdk/1.0.4/bridge.js', () => {
            console.log('addPassSc')
            cb1()
          })
        } else {
          console.log('noAddPassSc')
          cb1()
        }
      } else if (this.env === 'driver') {
        console.log('inDri')
        cb2()
        // if (!window.didi.dbridge) {
        //   loadScript('//static.udache.com/driver/assets/js/bridge/dbridge.js', () => { cb2() })
        // } else {
        //   cb2()
        // }
      } else {
        this.setAlertVisible(true)
        this.alertVisible = true
        showAlert(this, {
          content: '请在滴滴出行客户端内打开该页面',
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    clearText () {
      this.id_no = ''
    },
    faceRegPasser () {
      let _this = this
      // let userInfoObj = {
      //   name: _this.name,
      //   idCard: _this.id_no
      // }
      console.log('faceRegPasser')
      _this.hasInBridge = false
      const { biz_code } = window.GlobalSet.query
      window.D.bridge.call('faceRecognize', {
        bizCode: biz_code || defaultBizCode(),
        sessionId: _this.sessionid,
        // userInfo: userInfoObj,
        debug: false // true线下/false线上
        }, function (errNo, rest) {
          if (!_this.hasInBridge) {
            _this.hasInBridge = true
            if (errNo.errno * 1 === 0) {
              if (rest.faceResultCode * 1 < 100) {
                console.log('rest', rest)
                sendOmega(name_auth_omega_summary['pub_trinity_passer_face_auth_suc_sw'])
                _this.verifyFace()
              } else if (rest.faceResultCode * 1 === 104) {
                sendOmega(name_auth_omega_summary['pub_trinity_passer_face_auth_fail_sw'])
                _this.setAlertVisible(true)
                showAlert(_this, {
                  content: '抱歉，您的人脸识别失败已达5次，请联系客服。',
                  onConfirm: () => {
                    _this.setAlertVisible(false)
                  }
                })
              }
            }
          }
        })
      },
    faceRegDriver () {
      let _this = this
      // let userInfoObj = {
      //   name: _this.name,
      //   idCard: _this.id_no
      // }
      _this.hasInBridge = false
      const { biz_code } = window.GlobalSet.query
      dbridge.faceRecognize({
        sessionId: _this.sessionid,
        bizCode: biz_code || defaultBizCode(),
        // userInfo: JSON.stringify(userInfoObj),
        onlineStatus: false
      }, function (rest) {
        if (!_this.hasInBridge) {
          _this.hasInBridge = true
          if (rest.faceResultCode * 1 < 100) {
            sendOmega(name_auth_omega_summary['pub_trinity_driver_face_auth_suc_sw'])
            console.log('rest', rest)
            _this.verifyFace()
          } else if (rest.faceResultCode * 1 === 104) {
            sendOmega(name_auth_omega_summary['pub_trinity_driver_face_auth_fail_sw'])
            _this.setAlertVisible(true)
            showAlert(_this, {
              content: '抱歉，您的人脸识别失败已达5次，请联系客服。',
              onConfirm: () => {
                _this.setAlertVisible(false)
              }
            })
          }
        }
      })
    },
    faceReg () {
      console.log('inInitScript')
      this.initScript(this.faceRegPasser, this.faceRegDriver)
    },
    // 人脸识别
    async verifyFace () {
      console.log('verifyFace')
      const { ticket, biz, name, id_no, roleId, sessionid } = this
      let params_face = {
        name,
        id_no: '',
        id_no_encrypted: id_no && rsaEncrypt(id_no),
        ticket: ticket || '',
        doc_id: this.docId,
        biz,
        session_id: sessionid
      }
      if (JSON.stringify(roleId) === '{}') {
        params_face.role = 0
      } else if (roleId * 1 !== 999) {
        params_face.role = roleId
      }
      console.log('params_face', params_face)
      const res = await fetchPost({
        url: urlObj.verifyRn,
        data: params_face,
      })
      const { errno, errmsg } = res
      const { back_url, from_page, isCloseWebview } = window.GlobalSet.query
      if (errno === 0) {
        sendOmega(name_auth_omega_summary.pub_trinity_auth_submit__suc_ck)
        if (back_url) {
          location.replace(decodeURIComponent(back_url))
        } else if (from_page === 'conflict') {
          return this.conflictNext()
        } else if (isCloseWebview * 1 === 1) {
          this.closeWebView()
        } else {
          toast(this, { txt: '认证成功', type: 'correct', time: 1000 })
          this.goApp()
        }
      } else {
        sendOmega(name_auth_omega_summary.pub_trinity_auth_submit__fail_ck)
        this.setAlertVisible(true)
        showAlert(this, {
          content: errmsg || '认证失败',
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    /*
      0: 认证成功(包括人脸认证成功)
      1: 需要进行人脸识别
      2: 身份证信息与当前登录用户不符
      3: 身份证信息有误
      4: 身份证信息错误已达5次
      5: 身份证号码最多绑5个账号
      6: 没有通过短信验证
      7: 当前身份证下其他账号有未完成的订单
      8: 实名认证失败
      9: 实名信息错误
      10: 实名次数已达限制
      11: 登录用户不是乘客
      12: 姓名信息与当前登录用户不符
      */
    async verifyRealname () {
      const { ticket, roleId } = this
      let { biz, channel_id, biz_code, back_url, from_page, isCloseWebview } = window.GlobalSet.query
      let _params = {
        ticket: ticket || '',
        name: this.name,
        id_no: '',
        id_no_encrypted: this.id_no && rsaEncrypt(this.id_no),
        biz,
        doc_id: this.docId,
        channel_id
      }
      if (JSON.stringify(roleId) === '{}') {
        _params.role = 0
      } else if (roleId * 1 !== 999) {
        _params.role = roleId
      }
      console.log('verifyStatus_params', _params)
      const res = await fetchPost({
        url: urlObj.verifyRn,
        data: _params
      })
      const { errno, errmsg } = res
      let errTip = VERIFY_REANME_TIP[String(errno)] || errmsg || VERIFY_REANME_TIP.default
      const omegaEventId = errno === 0
        ? 'pub_trinity_auth_submit__suc_ck'
        : 'pub_trinity_auth_submit__fail_ck'
      sendOmega(name_auth_omega_summary[omegaEventId], {
        errno
      })
      if (errno * 1 === 0) {
        errTip = ''
        toast(this, { txt: '实名认证成功', type: 'correct', time: 1000 })
        if (back_url) {
          location.replace(decodeURIComponent(back_url))
        } else if (from_page === 'conflict') {
          return this.conflictNext()
        } else if (isCloseWebview * 1 === 1) {
          this.closeWebView()
        } else {
          this.goApp()
        }
      } else if (errno * 1 === 1) {
        if (from_page === 'conflict') {
          waitBridgeReady().then(() => {
            window.DidiJSBridge.callHandler('faceRecognize', {
              token: ticket || '',
              sessionId: this.sessionid,
              userInfo: {
                bizCode: biz_code || defaultBizCode()
              }
            }, response => {
              console.log(response)
              const {code, msg} = response
              if (code !== 1) {
                this.setAlertVisible(true)
                showAlert(this, {
                  content: msg || '认证失败',
                  onConfirm: () => {
                    this.setAlertVisible(false)
                  }
                })
              } else {
                this.verifyFace()
              }
            })
          })
        } else {
          this.sessionIdData()
        }
      }
      // 需要进行人脸识别 不需要进行错误信息弹窗提示
      if (errTip && errno !== 1) {
        this.setAlertVisible(true)
        showAlert(this, {
          content: errTip,
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    submit () {
      sendOmega(name_auth_omega_summary['trinity_id_ck'])
      if (!this.name || !this.id_no || !this.testID()) {
        toast(this, { txt: '请输入有效的姓名和身份证号码', type: 'warn', time: 1000 })
        return
      }
      const { type } = this.$route.query
      if (type && +type === 2) {
        this.unbind()
      } else {
        toast(this, { txt: '认证中', time: 1000 })
        this.verifyRealname()
      }
    },
    async unbind () {
      toast(this, { txt: '解绑中', time: 1000 })
      const { id_no, name, cell_id } = this
      let parmas = {
        ticket: this.ticket || '',
        id_no: '',
        id_no_encrypted: id_no && rsaEncrypt(id_no),
        name,
        cell_id: '',
        cell_id_encrypted: cell_id.cell_id && rsaEncrypt(cell_id.cell_id)
      }
      const res = await fetchPost({
        url: urlObj.unbind,
        data: parmas
      })
      const { errno, errmsg, data } = res
      const omegaEventId = errno === 0
        ? 'pub_trinity_auth_unbound_suc_sw'
        : 'pub_trinity_auth_unbound_fail_sw'
      sendOmega(name_auth_omega_summary[omegaEventId], {
        errno
      })
      if (errno * 1 === 0) {
        toast(this, { txt: '解绑成功', type: 'correct', time: 1000 })
        this.goApp()
      } else if (errno * 1 === 5008) {
        if (this.env === 'passenger') {
          this.isShowOrder = true
          this.myorders = data.orders
        } else {
          this.setAlertVisible(true)
          showAlert(this, {
            content: '抱歉，该账号下有未支付订单，请您在乘客端登录该账号完成支付后，方可解绑该账号。',
            onConfirm: () => {
              this.setAlertVisible(false)
            }
          })
        }
      } else if (errno * 1 === 1203) {
        // this.$router.push({
        //   name: 'MesVerify',
        //   query: {
        //     type: 2
        //   }
        // })
        initUnVerifiedRouter(this)
      } else {
        this.setAlertVisible(true)
        showAlert(this, {
          content: errmsg || '好像出错了',
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    async postOcrIdno (imgData) {
      const res = await fetchPost({
        url: urlObj.ocrIdno,
        data: {
          ticket: this.ticket,
          data: imgData
        }
      })
      const { errno, data, errmsg } = res
      let errorTip = ''
      if (errno * 1 === 0) {
        const { name, id_no } = data
        if (id_no && name) {
          this.name = name
          this.id_no = id_no
          sendOmega(name_auth_omega_summary['pub_trinity_idcard_upload_suc_ck'], {
            errno
          })
        } else {
          sendOmega(name_auth_omega_summary['pub_trinity_idcard_upload_fail_ck'], {
            errno
          })
          errorTip = '您上传的图片信息识别不完整，请重新上传或手动输入'
        }
      } else if (Number(errno) === 1021) {
        // 操作频繁
        sendOmega(name_auth_omega_summary['pub_trinity_idcard_upload_fail_ck'], {
          errno
        })
        errorTip = errmsg
      } else {
        sendOmega(name_auth_omega_summary['pub_trinity_idcard_upload_fail_ck'], {
          errno
        })
        errorTip = '图片信息无法识别，请重试或尝试手动填写'
      }
      if (errorTip) {
        this.setAlertVisible(true)
        showAlert(this, {
          content: errorTip,
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    async sessionIdData() {
      const { ticket } = this
      let { biz } = window.GlobalSet.query
      let _params = {
        ticket: ticket || '',
        name: this.name,
        idno: '',
        idno_encrypted: this.id_no && rsaEncrypt(this.id_no),
        biz: biz || defaultBiz()
      }
      const res = await fetchPost({
        url: urlObj.getSessionId,
        data: _params
      })
      const { errno, errmsg, data } = res
      if (errno * 1 === 0) {
        if (data.sessionId) {
          this.sessionid = data.sessionId
          this.faceReg()
        } else {
          this.setAlertVisible(true)
          showAlert(this, {
            content: errmsg || '好像失败了',
            onConfirm: () => {
              this.setAlertVisible(false)
            }
          })
        }
      } else {
        this.setAlertVisible(true)
        showAlert(this, {
          content: errmsg || '好像失败了',
          onConfirm: () => {
            this.setAlertVisible(false)
          }
        })
      }
    },
    photo () {
      const opts = UOPLOAD_POTO_CONG[this.env]
      let _this = this
      if (this.env === 'passenger') {
        window.D.bridge.call('photograph', opts, function (err, ret) {
          console.log(err, ret, '===')
          if (err.errno * 1 === 0) {
            _this.hideGuide()
            if (ret.photograph_result * 1 !== 0) {
              console.log('ret.photograph_result', ret.photograph_result)
            }
            let imgData = ret.image
            if (imgData !== '') {
              toast(_this, { txt: '身份证号码识别中…', time: 1000 })
              _this.postOcrIdno(imgData)
            }
          } else {
            _this.setAlertVisible(true)
            showAlert(_this, {
              content: '好像出错了，请稍后再试',
              onConfirm: () => {
                _this.setAlertVisible(false)
              }
            })
            _this.hideGuide()
          }
        })
      } else if (this.env === 'driver') {
        dbridge.chooseImage(opts, (res) => {
          _this.hideGuide()
          // TODO data:image/png;base64, 前缀去掉
          let imgData = res.image
          _this.postOcrIdno(imgData)
        })
      }
    },
    handleGoQuestion () {
      sendOmega(name_auth_omega_summary['pub_identity_faq_ck'], this.omegaParams)
      this.$router.push({
        path: '/Faq',
        query: {
          ...window.GlobalSet.query
        }
      })
    },
    // from_page === 'conflict' 认证成功提示，关闭当前页面
    conflictNext() {
      waitBridgeReady().then(() => {
        toast(this, {
          txt: '认证成功，页面关闭中...',
          time: 2000,
          onTimeout: () => {
            window.DidiJSBridge.callHandler('closeWebView', {}, () => {})
          }
        })
      })
    },
    // 关闭端Webview
    closeWebView() {
      if (this.env === 'passenger') {
        window.D.bridge.call('closePage', {}, () => {})
      } else if (this.env === 'driver') {
        dbridge.closePage()
      }
    },
    // 进入首页
    goApp() {
      this.$router.replace({
        name: 'App',
        params: {
          needFresh: true
        }
      })
    }
  },
  created () {},
  mounted () {
    sendOmega(name_auth_omega_summary['pub_trinity_id_sw'])
    setPageTitle({
      title: '统一实名认证'
    })
  },
}
</script>
<style lang="scss">
@import '~common-css/func.scss';
* {
  padding: 0;
  margin: 0;
  outline: none;
}

.cube-checkbox-label a {
  position: relative;
  z-index: 1;
}

input::-webkit-input-placeholder {
  color: #ccc;
}

input {
  border: none;
  outline: none;
}

*:focus {
  outline: none;
  border: none;
}

.nameID {
  padding: .4rem;
  background: #F3F4F5;
  height: 100%;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  .item-group {
    background: #FFFFFF;
    .item {
      height: px2rem(100);
      line-height: px2rem(100);
      font-size: px2rem(28);
      padding-left: px2rem(32);
      color: #666;
      .item-name {
        display: inline-block;
        width: px2rem(152);
        text-align: left;
      }
      input {
        width: 70%;
        font-size: px2rem(28);
        border: none;
        outline: none;
        -webkit-tap-highlight-color: transparent;
      }
      .icon-clear {
        position: absolute;
        width: px2rem(32);
        height: px2rem(32);
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAABN1JREFUaAXtWrtPFEEcvofFSUIh2qCFDSb8AUdsRSKJGsOjoLJRhIMSYkjsKEwkFlDyEhutaJQGEgyBUuJdQ0WhIRaXazQUl+Al5ji/77J72ZnZvdnZ2+PWC5Nsdnbm9/i++c1rdzYWu0yXLRCJFoiHjWJmZuZqqVR6cH5+3g/bvZVKpScej1/DvZO+kC8if4r7dzweJxKJ/VQq9WVpaekP68NKoRCbnp4m8CGQGQKwQVwdhgDPIL8LklsgvLW8vHxqqK+IN0RscnKyA0BmQWoOlqsRUTyYFxRh8y1sLq6trZFwoBSI2ObmZnJvb28czufhtTuQZ71SAQTnBwYGNsbGxsp6cVHCmNjU1NQtEPqMKy2aas4TyGVxDa+srORNPBgRQ9e7C+OfcDUrSl7YC6gYQdc89BKQyxNygddzJpN5iroDXBdNipDo88DCwGdtSmolIECD6HofkL3iR75JMvQ9mk6nf+RyuSOdD21XtLrfAQyldMYuqL4EP/d03bIuMU4UWJu+wVArul+9dipgzeurN6F4jjFO6Zz9IkiKhLuJjRi92HtWdHV1TUA546UYgfKbJycneYy3nBsW167IHQWEuZeLWheUOXAZ6HHbobh2RSyIs/8BKZLstrAyLySFmLWh5d7POMHJNpQqxorQsXSNVTFc5ohZVlSIQZA79CAb2oXV1dXHADgBfRNyJDVBXegtyAB9PHdamAVRhZj16iEI6R7Y2ujnrygHgBuYil8g64dchbLUoS5tBImcG2aBGF8SYZ/vU0YJLfYQu5NxWwnry3sf5KqkKGvr0QZt2c8G90ELe01FIMY3X9SYviTSWByA1g3IeZFapy0aNEwdFvaamkAMIe2v1Zhn/JILm1QVqYxdIAaJXnM+gkaVHLZiz+1SqVsqpCjLaEM+SKRsN7wL2AVicNDjlAyYj6P13rmR47iTxxRl4adRUjEZu2AQY+QXBK4HJCSrKdFxCpB4WKRoF7Ppb8yuN2wfcsSCrF+2LfmuRM4WCJsU7SIgAnaBmO24He4CMYSzGCIpz64oTSihuJSxC8QQzoY/VFooFVLsfm4TCuT97FC05GXsAjGw5qtKo8mVFCcKr9kSDhsmJ2MXiMHBcYOsPEnBLmdgZUIJsVsK2AViWGf2GyCmI2Wbbgo5GbtAjKce8B7ke7lfUs0id2Zht+3HBGLWUc5urdZnBv17x7mj8LlOuUaOtny6dYrtysdQAjFKIqRbTg0/ecxIj/Cd5A1lfZKyzQrkaIO27Eq/dzfMwpaKhviaXS6XfyIrrOR+nKC1twGM71OKXY0+36J3gpCC3WIymbwtn6kpn9+y2WwJn5FZfl8Dxq36DgpNSdEOdahrnNAgrzEMlOGjdEVaRsst4sZPW1FPBQurglOJGCXwDfIvosbt1RNFI0IFiNZLfCf56gbJNWIU5EkiFLNuSlEoIzZi9MLiSYzHo1AehmIUuySPcYfrHeF6EmNLYFDmcRvBxaObqCRiGbGweWJyHWNOaYy3PMYbp/9RZ3mr8ojUM4wr7SKuJUYCIHfEk0RkuXi26lSzRFJ4/f9ITLpktOZYp5vtdbjOFkIXOMT2pQ8td2GzJX3RJ33rouSsN4qYrdiWP7DY5HjnASFatH1+OXKSY77tfhKTCfI5Kr/1uWG7LLtsgRa0wD9doITvQdqhwgAAAABJRU5ErkJggg==');
        background-repeat: no-repeat;
        margin-top: px2rem(34);
        right: px2rem(60);
        background-size: px2rem(32);
      }
      .icon-scan {
        position: absolute;
        width: px2rem(32);
        height: px2rem(32);
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAkVJREFUaAXtmjFuwkAQRSchBRIFVJwAEAeggAtQAYIDUCPRIRpuQc0tEFAgLgAFB0DiApTQ0aAkP5JXO8s6WUWxYTY71bCztt/fGY9t7Jf3TyMP7dVDTV+SvBX2pmfsdrvRYrGg7XZLl8tFD8X67XabWq1WbPw3gdVqRcvl0mnTfD5PjUaDOp0OZTIZtQ0TBlHr9VoFJThIQMTc6/UUMitFZEqqmexMmGv5PaN4k50Je0bg3zJ5K4w1j7jV6Xa71Gw2WdeJm/sX4+iytk6Lrr3ZbGg+n/94GKeMpSnqO2K0c7C4mJMw/frgstMk57iyOAlLEjSpfQdhSa1sUvv1NmOs3eOGVoK5cL6EB00JqdQYvT3HgjAtyyLckDERadIg2XVsMBhoIXnubDZT0KEU1VIIcULGhCRKYXqbsXATrHIsxPG2FIMwIRWoMEPG1FIIcdhNMN4k2sz2P7ptXlpjLpxMWNzr0WcT5sIZzrG0yuyvjvM/MpbNZq0LZr7ftU5KaTCOxWRnGSsUCla83W5nHX/EYByLyc66YrlcptPpdMeL7z9g9Xqd8MHIIwyZgqiIxWQAu27sseVwONB0OtXjP/qP/jInAhyNRlStVqOfxEoRgUqlooJSHDDrosDNhGGg3+9TLpeDK8LACmbT7oQVi0UaDocixEEUWMFs2p0wTCiVSjSZTJ66LFF+YASrzVhX1CdgFcbjMaGh7Pd7Oh6PdD6f6Xq96tNS83GdQktH96vVanfnlAnCuqIZlPzbWoqSBUXs3gr7AGqFmY+YpWxWAAAAAElFTkSuQmCC');
        background-repeat: no-repeat;
        margin-top: px2rem(34);
        right: px2rem(60);
        background-size: px2rem(32);
      }
    }
    .name {
      &::after {
        content: '';
        display: block;
        border-top: 1px solid #EBEBEB;
      }
    }
    &::after {
      content: '';
      border-top: 1px solid #EBEBEB;
      display:block;
    }
  }
  .name-tips, .tips {
    font-size: px2rem(20);
    color: #999;
    text-align: left;
    line-height: px2rem(40);
    padding: px2rem(20) px2rem(32);
  }
  .name-tips {
    // background: #FAFAFA;
    color: #fc9153;
    padding: 0 0 0 px2rem(15);
  }
  .name-tips a {
    color: #fc9153;
    text-decoration: underline;
  }
  .guide {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: #25262D;
    .close{
      position: absolute;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAHlSURBVFgJzdjBSsNAEIDh4kvopQXBiy/gA/QNPAmlt4JX382TJ+vFV1AQLB4s9CGk8Z8kU5O0u9lsdhYHhk3Sdedjsik2k0kdRVHckh/kEznT6zlG6p2Tj+QnuWjV5MId+UNqbDjIAqTOBfmmhRn35KoEciAda8I4LcMcSJUurC5dApcTzuRWusIMSEEXTC3bM9q3ad3j9sklpy/MTnqLBca6z+R1u1zr7Es6NyOlQ75I1kGK9HVMHN/kVUnlIAuQOsNg2khrYDTMGjgaZgWsYe+MvvjbYwpxjaySZA+yjuyxdDAFjwWawcYCzWGxwGywCOANuPR7TCGukaIhDwnTvBH+VLogruuUHQO0gyk4EmgPiwTmgzWAsvlDYq5/k2VEFPLNr3D5XTD9j7B8wIEdU5iOdh0cCbMDBsLkqZyT0iFfpOsgVUI2/+HrgvlT0h44FKZP5ABg3K+6WJg5cCzMDJgKlhxYw5ovVbh0FIfNr4C+kRXkv5m+h2Qj806uxQdxP3hPrnZ8MRpoDVPqYGAuWAcot9AX1S1mhrxR9MXgPaYQ10gx2YN9wLW8ZfJt1OQwBQcAd4JbkHuyG2awQOB9OQ/VimwCzWE9wAf9XIFLgFvylaxe3LVm2J1QT/bgmtyRVcco9wvfFIcHjow6fAAAAABJRU5ErkJggg==');
      width: 1rem;
      height: 1rem;
      background-repeat: no-repeat;
      background-size: contain;
      right: 1rem;
      top: 1rem;
    }
    .img {
      img {
        width: px2rem(600);
        margin-left: px2rem(75);
        margin-top: px2rem(202);
      }
    }
    .tips {
      margin-top: px2rem(139);
      text-align: center;
      color: #FFFFFF;
      .tip1 {
        opacity: 0.6;
        font-size: px2rem(24);
      }
      .tip2 {
        padding-top: px2rem(32);
        font-size: px2rem(32);
        line-height: px2rem(48);
        color: #fff;
      }
    }
    .btn {
      width: px2rem(600);
      height: px2rem(100);
      margin-top: px2rem(115);
      margin-left: px2rem(75);
      background: #FC9153;
      color: #fff;
      font-size: px2rem(32);
      border-radius: 4px;
      text-align: center;
      line-height: px2rem(100);
    }
  }
  .cube-btn {
    font-size: 20px;
  }
}
</style>
